import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class System_permissions extends PureComponent {
  render() {
    return (
      <div className="row" id="system_permissions">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>System Permissions</h2>
              <p>
                There are a few special system permissions. These permissions do
                not follow the normal format of object|rlp|permission instead
                they always uppercase. These permissions include ADMIN which is
                the highest level position and other useful system permissions
                like the ability to read dashboards or reports.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>System Permissions List</h2>
            </section>
            <section>
              <h3>System Administrator</h3>
              <p>
                System administrator is the highest level permission and has
                full access to all administration settings, all objects both
                defined and not defined by modules and will ignore all record
                level permission settings. System administrator is the only
                permission that can view the audit history of a deleted record.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">ADMIN</span>
              </div>
            </section>
            <section>
              <h3>Authoriser</h3>
              <p>
                The authoriser permission give users the ability to test any user’s username and passwords against the authentication engine.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">AUTH</span> <br />
              </div>
            </section>
            <section>
              <h3>Audit Clean</h3>
              <p>
                Allows a user to delete record audit logs that are older than 60 days.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">AUDITCLEAN</span> <br />
              </div>
            </section>
            <section>
              <h3>Dashboard</h3>
              <p>
                The dashboards permission gives the use of the ability to view a
                dashboard. The data within the dashboard is managed by the
                individual users access to that particular data object or record
                level permission.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">DASHBOARDREAD</span> <br />
              </div>
            </section>
            <section>
              <h3>Send Emails</h3>
              <p>
                Allows users to send an email using the API
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">EMAILSEND</span> <br />
              </div>
            </section>
            <section>
              <h3>Keywords</h3>
              <p>
                Keywords are a great way of tagging records and a shared across
                all users. For a user to be able to use a key words function
                they will require the key words read permission. For user to add
                a new keyboard they will need the key words create permission.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">KEYWORDREAD</span> <br />
                <span className="jsonY">KEYWORDCREATE</span> <br />
              </div>
            </section>
            <section>
              <h3>No Audit</h3>
              <p>
                Gives a user the ability to update and create records without leaving an audit trail.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">NOAUDIT</span> <br />
              </div>
            </section>
            <section>
              <h3>Create Notification</h3>
              <p>
                Allows users to create notifications using the API
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">NOTIFICATIONCREATE</span> <br />
              </div>
            </section>
            <section>
              <h3>Reports</h3>
              <p>
                The reports permission gives the use of the ability to view a
                report. The data within the report is managed by the individual
                users access to that particular data object or record level
                permission. There is an additional permission to allow users to
                download a report.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">REPORTSREAD</span> <br />
                <span className="jsonY">REPORTSDOWNLOAD</span> <br />
              </div>
            </section>
            <section>
              <h3>Users</h3>
              <p>
                The user's permission give users read only access to all the
                users in the system. This is useful in workflows where one user
                needs to assign a record to another user.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <span className="jsonY">USERSREAD</span> <br />
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default System_permissions;



// WEBPACK FOOTER //
// ./src/components/knowlege/security/System_permissions.js